import { AlertType, IAlert } from '@/interfaces/IAlert';
import { vueData } from '@/VueData';
import { getServerErrorMessage } from '@/utils/error.utils';

export function useUi() {
  function showToast(
    type: AlertType,
    message: string,
    action?: { text: string; cb: () => void },
    durationMs?: number
  ): IAlert {
    return vueData.addAlert(message, type, durationMs, action);
  }

  /** Withdraws a toast (e.g. an undo that no longer applies). */
  function hideToast(alert: IAlert) {
    vueData.removeAlert(alert);
  }

  // Message from fetch error
  function serverError(error: unknown, defaultMessage = 'Error fetching data') {
    console.error('Server error', error);

    const errorMessage = getServerErrorMessage(error, {
      defaultMessage,
    });

    vueData.logException(error, 'Server error', true, errorMessage);
    showToast(AlertType.Error, errorMessage);
  }

  return {
    showToast,
    hideToast,
    serverError,
  };
}
